import React from 'react';

const Tile = ({ title, subtitle, icon, scrollTo, section, formType }) => {

    return (
      <div onClick={() => scrollTo(section, formType)} className="tile">
        <div className="tile-item">{icon}</div>
        <h2 className="tile-item">{title}</h2>
        <p className="tile-item tile-subtitle">{subtitle}</p>
      </div>
    );
};

export default Tile;